import { useUser } from "@/features/users/hooks/useUsersQueries";

interface AuditLogActorLabelProps {
  userId?: string;
  className?: string;
}

/** Resolves an audit log actor key to a display name (falls back to the raw id). */
export function AuditLogActorLabel({ userId, className }: AuditLogActorLabelProps) {
  const { data: user } = useUser(userId ?? "");

  if (!userId) {
    return <span className={className}>—</span>;
  }

  if (!user) {
    return <span className={className}>{userId}</span>;
  }

  const name = [user.firstName, user.lastName].filter(Boolean).join(" ");
  return <span className={className}>{name || user.email}</span>;
}
